module.exports = __webpack_public_path__ + "static/img/A (17).f9c89219.png";